<template>
  <v-card class="grey lighten-4 elevation-0">
    <v-card-text v-if="!fatalError">
      <v-container fluid>
        <!-- <form @submit.prevent.stop="submit" v-if="!submited"> -->
        <div v-if="!submited">
          <v-layout row>
            <v-flex xs12 md3>
              <v-subheader>Identificação do aluno</v-subheader>
            </v-flex>
            <v-flex xs12 md9>
              <v-select label="Curso" v-model="exam.course" data-vv-as="Curso" data-vv-name="exam.course"
                v-validate="'required'" :errors="vErrors.collect('exam.course')" required autocomplete
                prepend-icon="class"  :disabled="studentChecked" :readonly="readonly" :no-data-text="noDataText"
                :items="userCourses" item-text="name" item-value="id" @change="exam.type = ''"></v-select>
              <v-select label="Aluno" v-model="exam.student" data-vv-as="Aluno" data-vv-name="exam.student"
                v-validate="'required'" :errors="vErrors.collect('exam.student')" required autocomplete
                prepend-icon="person" :disabled="!exam.course" v-if="!studentChecked" :loading="studentLoading"  :no-data-text="noDataText"
                :items="students" :search-input.sync="searchStudentVal" item-text="name_and_id" item-value="id"></v-select>
              <v-text-field label="Aluno" v-model="exam.studentName" v-if="studentChecked" readonly
                prepend-icon="subject"></v-text-field>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
          <v-layout row>
            <v-flex xs12 md3>
              <v-subheader>Informações do trabalho</v-subheader>
            </v-flex>
            <v-flex xs12 md9>
              <v-select  label="Tipo" v-model="exam.type" data-vv-as="Tipo" data-vv-name="exam.type"
                v-validate="'required'" :errors="vErrors.collect('exam.type')" required
                prepend-icon="create" :disabled="studentChecked" :readonly="readonly" :no-data-text="noDataText"
                :items="courseTypes" item-text="name" item-value="id"></v-select>
              <template  v-if="studentChecked">
                <v-text-field label="Título" v-model="exam.title" data-vv-as="Título" data-vv-name="exam.title"
                  v-validate="'required'" :errors="vErrors.collect('exam.title')" required
                  prepend-icon="title" :readonly="readonly"></v-text-field>
                <!-- <v-text-field label="Tema" v-model="exam.topic" data-vv-as="Tema" data-vv-name="exam.topic"
                  v-validate="'required'" :errors="vErrors.collect('exam.topic')" required
                  prepend-icon="subject" :readonly="readonly"></v-text-field> -->
              </template>
            </v-flex>
          </v-layout>
          <template v-if="studentChecked">
            <v-divider></v-divider>
            <v-layout row>
              <v-flex xs12 md3>
                <v-subheader>Informações da sessão</v-subheader>
              </v-flex>
              <v-flex xs12 md9>
                <v-menu lazy :close-on-content-click="true" v-model="menuReleaseDate"
                  transition="v-scale-transition" offset-y :nudge-left="40">
                  <v-text-field label="Data de divulgação" v-model="formattedReleaseDate" data-vv-as="Data de divulgação" data-vv-name="exam.release_date"
                   :errors="vErrors.collect('exam.release_date')" readonly
                    prepend-icon="date_range" slot="activator"></v-text-field>
                  <v-date-picker v-model="exam.release_date" no-title scrollable locale="pt-BR"></v-date-picker>
                </v-menu>

                <v-menu lazy :close-on-content-click="true" v-model="menuDate"
                  transition="v-scale-transition" offset-y :nudge-left="40" :disabled="readonly">
                  <v-text-field label="Data" v-model="formattedDate" data-vv-as="Data" data-vv-name="exam.date"
                    v-validate="'required'" :errors="vErrors.collect('exam.date')" required readonly
                    prepend-icon="date_range" slot="activator"></v-text-field>
                  <v-date-picker v-model="exam.date" no-title scrollable locale="pt-BR"></v-date-picker>
                </v-menu>
                <v-menu lazy :close-on-content-click="false" v-model="menuTime"
                  transition="v-scale-transition" offset-y :nudge-left="40" :disabled="readonly">
                  <v-text-field label="Hora" v-model="exam.hour" data-vv-as="Hora" data-vv-name="exam.hour"
                    v-validate="'required'" :errors="vErrors.collect('exam.hour')" required readonly
                    prepend-icon="access_time" slot="activator"></v-text-field>
                  <v-time-picker v-model="exam.hour" format="24hr"></v-time-picker>
                </v-menu>
                <v-text-field label="Local" v-model="exam.place" data-vv-as="Local" data-vv-name="exam.place"
                  v-validate="'required'" :errors="vErrors.collect('exam.place')" required
                  prepend-icon="edit_location" :readonly="readonly"></v-text-field>

                <v-text-field label="Vagas" v-model="exam.vacancies" data-vv-as="Vagas" data-vv-name="exam.vacancies"
                :errors="vErrors.collect('exam.vacancies')"
                prepend-icon="persons"></v-text-field>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row>
              <v-flex xs12 md3>
                <v-subheader>Composição da banca</v-subheader>
              </v-flex>
              <v-flex xs12 md9>
                <v-select label="Presidente" v-model="exam.chair" data-vv-as="Presidente" data-vv-name="exam.chair"
                  v-validate="'required'" :errors="vErrors.collect('exam.chair')" required autocomplete
                  prepend-icon="person" :readonly="readonly" :no-data-text="noDataText"
                  :items="teachersComputed" item-text="name" item-value="id"></v-select>
                <v-checkbox v-model="chairIsExaminer" color="primary" :disabled="readonly">
                  <div slot="label">O presidente também é examinador</div>
                </v-checkbox>
                <template>
                  <v-layout row v-for="(examiner, idx) in exam.examiners" :key="'examiner-' + idx">
                    <v-flex xs12 sm11>
                      <v-select :label="'Examinador '+(idx+1)" v-model="exam.examiners[idx]" :no-data-text="noDataText"
                        prepend-icon="person" :rules="[(v) => !!v || 'O examinador ' +(idx+1)+ ' precisa ser informado']" required autocomplete :readonly="readonly"
                        :items="teachersComputed" item-text="name" item-value="id"></v-select>
                    </v-flex>
                    <v-flex xs12 sm1 v-if="!readonly">
                      <v-btn fab dark small class="red" @click="exam.examiners.splice(idx, 1)">
                        <v-icon dark>remove</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </template>
                <v-layout row class="mb-4" v-if="!readonly">
                  <v-flex xs12 sm9>
                    <v-btn dark small class="green" @click="exam.examiners.push('')">
                      <v-icon dark>add</v-icon> Adicionar examinador
                    </v-btn>
                  </v-flex>
                </v-layout>
                <template>
                  <v-layout row  v-for="(substitute, idx) in exam.substitutes" :key="'substitute-' + idx">
                    <v-flex xs12 sm11>
                      <v-select :label="'Suplente '+(idx+1)" v-model="exam.substitutes[idx]" :data-vv-as="'Suplente '+(idx+1)" data-vv-name="exam.substitutes[idx]"
                        prepend-icon="person" :rules="[(v) => !!v || 'O suplente ' +(idx+1)+ ' precisa ser informado']" required autocomplete :readonly="readonly" :no-data-text="noDataText"
                        :items="teachers" item-text="name" item-value="id"></v-select>
                    </v-flex>
                    <v-flex xs12 sm1 v-if="!readonly">
                      <v-btn fab dark small class="red" @click="exam.substitutes.splice(idx, 1)">
                        <v-icon dark>remove</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </template>
                <v-layout row class="mb-4" v-if="!readonly">
                  <v-flex xs12 sm9>
                    <v-btn dark small class="green" @click="exam.substitutes.push('')">
                      <v-icon dark>add</v-icon> Adicionar suplente
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <template v-if="exam.id > 0 && exam.perms['viewEvaluations']">
              <v-layout row>
                <v-flex xs12 md3>
                  <v-subheader>Avaliação dos examinadores</v-subheader>
                </v-flex>
              </v-layout>
              <v-layout row class="mb-4">
                <v-flex xs12>
                  <exam-evaluations
                      :exam-id="exam.id"
                      :show-header="false"
                      :refresh-interval="isFinished ? null : 5"
                      v-on:updateNotaMedia="notaMediaUpdate($event)"
                  ></exam-evaluations>
                </v-flex>
              </v-layout>
              <v-divider></v-divider>
            </template>

            <v-layout row v-if="hasExternalEvaluation">
              <v-flex xs12 md3>
                <v-subheader>Nota Externa</v-subheader>
              </v-flex>
              <v-flex xs12 md9>
                <v-text-field
                    label="Nota"
                    v-model="externalNote"
                    id="externalNote"
                    :data-nvalue="exam.externalNote"
                    prepend-icon="star"
                    data-vv-as="Nota"
                    type="number"
                    step="0.01"
                    max="10"
                    required
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12 md3>
                <v-subheader>Resultado da banca</v-subheader>
              </v-flex>
              <v-flex xs12 md9>
                <v-text-field
                    label="Nota"
                    v-model="exam.finalScore"
                    data-vv-as="Nota"
                    data-vv-name="exam.finalScore"
                    v-validate="'required|min_value:0|max_value:10'"
                    :errors="vErrors.collect('exam.finalScore')"
                    type="number"
                    step="0.01"
                    required
                    prepend-icon="star"
                    readonly="readonly"
                ></v-text-field>
                <v-text-field :label="exam.finalScore >= 9 ? 'Recomendações' : 'Justificativa'" v-model="exam.notes" data-vv-as="Recomendações" data-vv-name="exam.notes"
                  :errors="vErrors.collect('exam.notes')"
                  prepend-icon="rate_review" multi-line auto-grow rows="3" :readonly="readonly"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12 text-xs-center v-if="!readonly">
                <v-alert info :value="vErrors.any()">
                  Algum campo não foi preenchido corretamente. Revise o preenchimento dos dados para continuar.
                </v-alert>
                <v-alert v-if="submitErrors.length" error :value="submitErrors">
                  Ocorreram os seguintes erros na submissão do formulário:
                  <ul>
                    <li v-for="(error, e_idx) in submitErrors" :key="e_idx">{{ error }}</li>
                  </ul>
                </v-alert>
                <v-btn dark color="success" type="buttom" :disabled="vErrors.any()" @click="submit()" v-if="exam.situation !== 'Finalizada'">
                  <v-icon left dark>done</v-icon> Finalizar
                </v-btn>
                <div class="show-status" v-else>
                  Status da banca: {{exam.situation}}
                </div>
              </v-flex>
            </v-layout>
            <v-flex v-if="readonly">
                <v-alert info :value="true">
                    Você não pode alterar os dados desta banca.
                </v-alert>
            </v-flex>
          </template>
        </div>
        <!-- </form> -->
        <v-layout row v-if="submited">
          <v-flex xs12>
              <v-card>
                <v-card-title class="green darken-1">
                  <span class="white--text">Registro confirmado</span>
                </v-card-title>
                <v-card-text height="75px">
                  <v-icon class="mr-4" dark>done</v-icon>
                  O registro da banca foi {{ edit ? 'atualizado' : 'registrado' }} com sucesso no sistema sob o
                    <v-chip class="green darken-1 white--text">
                      <router-link :to="{ name: 'examDetail', params: { id: exam.id } }">n.º {{ exam.id }}</router-link>
                    </v-chip>.
                </v-card-text>
                <v-card-text>
                  <exam-documents :exam-id="exam.id" :teachers="allTeachers"></exam-documents>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-btn dark class="orange darken-3" @click.stop="attendanceDialog = true">
                    Registrar e certificar presença dos participantes
                  </v-btn>
                  <v-btn dark class="green darken-1" to="/bancas/registrar">
                    Registrar outra banca
                  </v-btn>
                </v-card-actions>
              </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-alert :value="true" error v-if="fatalError">Erro ao carregar dados. Certifique-se de que a banca {{ id }} existe e você tem acesso a ela.</v-alert>
    <fullscreen-spinner></fullscreen-spinner>
    <v-dialog v-model="attendanceDialog" fullscreen lazy>
        <exam-attendance :exam-id="exam.id">
            <template slot="actions">
                <v-spacer></v-spacer>
                <v-btn color="info" @click="attendanceDialog = false">Fechar</v-btn>
            </template>
        </exam-attendance>
    </v-dialog>
  </v-card>
</template>

<script>
  import ExamMixin from './ExamMixin'
  import ExamDocuments from './ExamDocuments.vue'
  import ExamEvaluations from './ExamEvaluations.vue'
  import ExamAttendance from './ExamAttendance.vue'

  export default {
    name: 'ExamDetail',
    mixins: [ExamMixin],
    components: {
      ExamDocuments,
      ExamEvaluations,
      ExamAttendance,
    },
    data() {
      return {
        attendanceDialog: false,
        notaMedia: 0,
        externalNote:0,
        falta: false,
        externalValueSetting: 0,
        hasExternalEvaluation: false,
        errors: false,
        attendanceList: {}
      }
    },
    created: function() {
      this.getValueCursoSemestreConfig();
      this.loadAtt();
    },
    mounted: function () {
      let _this = this;

      setTimeout(function(){
        let ponteiro = document.getElementById('externalNote');
        if(ponteiro) {
          _this.externalNote = ponteiro.dataset.nvalue;
        }
      }, 1500);
    },
    watch: {
      externalNote: function () {
        this.somaNotaFinalNotaExterna();
      }
    },
    updated: function () {
      this.somaNotaFinalNotaExterna();
    },
    methods: {
      loadAtt: function () {
        this.loading = true 
        this.errors = false
        this.submitErrors = false
        let idBanca = this.$route.params.id;

        this.$http.post('attendanceList', { exam: idBanca }).then(response => {
          if (typeof response.data.status !== 'undefined' && response.data.status == 'ok') {
            var presencaObj = response.body.attendanceList;
            const presenca = Object.entries(presencaObj);

            presenca.forEach(([key, value]) => {
              
              var value = Object.entries(value);
                value.forEach(([k, v]) => {
                  if (k == 'present' && v == '0' ) {
                    this.falta = true;                
                  }
                });
            });
            
          }

        }, response => {
            console.log('Erro ' + this.examId)
        })  
        
      },  
      submit: function () {
        /* Segue tipos de status
        'Atrasada'
        'Em andamento'
        'Finalizada'
        'Pendente'
        'Exluida'
        */

        let _this = this;
        let aux = _this.exam.situation;

        if (this.falta) {
          
          this.$swal({
            type: 'warning',
            title: 'Atenção',
            text: "Existem pessoas sem registro de presença. Deseja realmente encerrar esta banca?",
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Sim',
            showCancelButton: true,
            cancelButtonColor: '#d33', 
            cancelButtonText: 'Não'
          }).then((result) => {
            if ((this.exam.finalScore) == 0.00 && (this.exam.notes.length < 1)) {
              _this.$swal(
                'Atenção!',
                'Não é possível encerrar a banca com nota 0, sem dar alguma justificativa.',
                'warning'
              )
            } 
            else  {
              _this.exam.situation = 'Finalizada';
              _this.exam.externalNote = this.externalNote;

              _this.$http.put('exams', _this.exam).then(response => {
                if (response.body !== null && typeof response.body.id !== 'undefined' && response.body.id > 0) {
                  _this.submitErrors = false
                  _this.submited = true
                  _this.exam.id = response.body.id
                  _this.exam.situation = response.body.situation
                  _this.isFinished = _this.exam.finalScore > 0
                  _this.$store.commit('setLastModifiedExam', _this.exam)

                } else {
                  _this.handleBadResponse(response)
                }
              }, response => {
                _this.exam.situation = aux;
                console.error('Erro ao submeter os dados para o servidor.')
                _this.handleBadResponse(response)

              });
            }
            
          })
        } else {
            
        this.$swal({
          type: 'warning',
          title: 'Atenção',
          text: "Deseja realmente finalizar esta banca?",
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Sim',
          showCancelButton: true,
          cancelButtonColor: '#d33',
          cancelButtonText: 'Não'
        }).then((result) => {
          if (this.exam.finalScore == 0.00 && this.exam.notes.length < 1) {
            _this.$swal(
              'Atenção!',
              'Não é possível finalizar a banca com nota 0, sem dar alguma justificativa.',
              'warning'
            )
          } 
          else  {
            _this.exam.situation = 'Finalizada';
            _this.exam.externalNote = this.externalNote;

            _this.$http.put('exams', _this.exam).then(response => {
              if (response.body !== null && typeof response.body.id !== 'undefined' && response.body.id > 0) {
                _this.submitErrors = false
                _this.submited = true
                _this.exam.id = response.body.id
                _this.exam.situation = response.body.situation
                _this.isFinished = _this.exam.finalScore > 0
                _this.$store.commit('setLastModifiedExam', _this.exam)

              } else {
                _this.handleBadResponse(response)
              }
            }, response => {
              _this.exam.situation = aux;
              console.error('Erro ao submeter os dados para o servidor.')
              _this.handleBadResponse(response)

            });
          }
        })
      }},
      notaMediaUpdate: function (newMedia) {
        this.notaMedia = newMedia.replace(',', '.');
        this.exam.finalScore = parseFloat(this.notaMedia).toFixed(1);
      },
      getValueCursoSemestreConfig: function () {
        let _this = this;
        let idBanca = this.$route.params.id;

        this.$http.post('getValueCursoSemestreConfig', {'idBanca': idBanca}).then(response => {
          let rs = response.body;
          _this.externalValueSetting = parseFloat(rs.result.valor);
          _this.hasExternalEvaluation = rs.success;
        }, response => {
          console.error('Erro ao submeter os dados para o servidor.')
          _this.handleBadResponse(response)
        });
      },
      somaNotaFinalNotaExterna: function() {
        let _this = this;

        let notaExterna = parseFloat(_this.externalNote.replace(',', '.'));
        if (isNaN(notaExterna)) media = 0;

        let media = parseFloat(_this.notaMedia);
        if (isNaN(media)) media = 0;

        if(_this.externalNote.length > 0) {
          let totSum = (media + (notaExterna * _this.externalValueSetting)).toFixed(2);
          if (totSum > 10) totSum = 10;

          _this.exam.finalScore = totSum;
        } else {
          _this.exam.finalScore = (media).toFixed(2);
        }
      }
    },
    computed: {
      teachersComputed() {
        let aTcher = [];

        this.teachers.forEach(function(e, i, a, t){
          let aux = {id: e.id, name: '[' + e.id + '] ' + e.name};
          aTcher.push(aux);
        });

        return aTcher;
      }
    }
  }
</script>

<style>
 .show-status {
   background-color: #004a9c;
   color: #FFF;
 }
</style>



// WEBPACK FOOTER //
// ExamDetail.vue?562c6584